import { ButtonBase } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import React from 'react';

const Custom = props => {
  const theme = useTheme();
  const classes = useStyles(props);
  return (
    <div className={classes.rootContainer}>
      <ButtonBase className={classes.buttonBase} onClick={props.onClick} disabled={props.loading}>
        <div className={classes.root}>
          {props.loading ? (
            <CircularProgress className={classes.progress} size={18} />
          ) : (
            <>
              {props.icon && (
                <div className={classes.iconContainer}>
                  {props.icon}
                </div>
              )}
              <span className={classes.text}>{props.text}</span>
            </>
          )}
        </div>
      </ButtonBase>
    </div>
  );
};

const useStyles = makeStyles(theme => {
  return {
    rootContainer: {
      flex: 1,
      borderRadius: 18,
      overflow: 'hidden'
    },
    buttonBase: {
      width: '100%'
    },
    root: props => {
      const style = {
        width: '100%',
        height: 36,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      };
      switch (props.variant) {
        case 'contained':
          return {
            ...style,
            backgroundColor: theme.palette.primary.main
          };
        case 'outlined':
          return {
            ...style,
            borderColor: theme.palette.divider,
            borderRadius: 18,
            borderStyle: 'solid',
            borderWidth: 1
          };
        default:
          return style;
      }
    },
    iconContainer: {
      width: 18,
      height: 18,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 12,
      marginRight: -8
    },
    progress: props => {
      const style = {

      };
      switch (props.variant) {
        case 'contained':
          return {
            ...style,
            color: theme.palette.primary.contrastText
          };
        case 'outlined':
          return style;
        default:
          return style;
      }
    },
    text: props => {
      const style = {
        marginLeft: 16,
        marginRight: 16,
        fontWeight: '500'
      };
      switch (props.variant) {
        case 'contained':
          return {
            ...style,
            color: !props.loading
              ? theme.palette.primary.contrastText
              : theme.palette.primary.contrastText === '#fff'
                ? 'rgba(256, 256, 256, 0.60)'
                : theme.palette.text.disabled
          };
        case 'outlined':
          return style;
        default:
          return style;
      }
    }
  };
});

export default Custom;